import {
  BASE_PROJECT_DEVELOPMENT_CONFIG,
  PRELIMINARY_DESIGN,
  ProjectDevelopmentStructure,
  ProjectTypeStructure,
  WORKING_DOCUMENTATION,
} from '../../../components';
import {
  ENGINEERING_SYSTEMS_CDN_PATH,
  ENGINEERING_SYSTEMS_STORAGE_PATH,
} from '../../../engineering-systems-constants';
import {
  SEWERAGE_PRELIMINARY_DESIGN_ID,
  SEWERAGE_WORKING_DOCUMENTATION_ID,
} from '../../sewerage-systems-constants';

export const SEWERAGE_PROJECT_TYPE_LIST: ProjectTypeStructure[] = [
  {
    ...PRELIMINARY_DESIGN,
    id: SEWERAGE_PRELIMINARY_DESIGN_ID,
    consultationSignup: {
      href: `${ENGINEERING_SYSTEMS_STORAGE_PATH}sistemy-vodosnabzheniya-i-kanalizacii-primer-eskiznogo-proekta.pdf`,
      src: `${ENGINEERING_SYSTEMS_CDN_PATH}/features/1.svg/1.svg`,
      label: 'Скачать пример',
    },
  },
  {
    ...WORKING_DOCUMENTATION,
    id: SEWERAGE_WORKING_DOCUMENTATION_ID,
    consultationSignup: {
      href: `${ENGINEERING_SYSTEMS_STORAGE_PATH}sistemy-vodosnabzheniya-i-kanalizacii-primer-rabochey-dokumentacii.pdf`,
      src: `${ENGINEERING_SYSTEMS_CDN_PATH}/heating/2.svg/2.svg`,
      label: 'Скачать пример',
    },
    priceUnits: '/м²',
  },
];

export const SEWERAGE_DEVELOPMENT: ProjectDevelopmentStructure = {
  ...BASE_PROJECT_DEVELOPMENT_CONFIG,
  id: SEWERAGE_WORKING_DOCUMENTATION_ID,
  compositionList: WORKING_DOCUMENTATION.compositionList,
  exampleHref: `${ENGINEERING_SYSTEMS_STORAGE_PATH}sistemy-vodosnabzheniya-i-kanalizacii-primer-rabochey-dokumentacii.pdf`,
  priceUnits: '/м²',
  schedule: WORKING_DOCUMENTATION.schedule,
};
